<template>
  <div>
    <section class="main-content" data-date="2022年08月04日" style="display: block">
        <div class="header">
            <h1>{{productName}}隐私政策</h1>
        </div>
        <div class="contact">
            <p class="ti2">本政策仅适用于{{productName}}产品或服务（以下统称“我们”）。</p>
            <p class="ti2">最近更新日期：2022年8月4日</p>
            <p class="ti2">如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
            <p class="ti2">电子邮件：sale@cn.gree.com</p>
            <p class="ti2">电话：4008365315</p>
            <p class="ti2">传真：0756-8614998</p>
        </div>
        <div class="summary">
            <p class="ti2">本政策将帮助您了解以下内容：</p>
            <ul>
                <li>我们如何收集和使用您的个人信息</li>
                <li>我们如何保护您的个人信息</li>
                <li>您的权利</li>
                <li>我们如何处理儿童的个人信息</li>
                <li>您的个人信息如何在全球范围转移</li>
                <li>本政策如何更新</li>
                <li>如何联系我们</li>
            </ul>
            <p class="ti2">我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
            <p class="ti2">请在使用我们的产品或服务前，仔细阅读并了解本《个人信息保护政策》。</p>

        </div>
        <div class="container">
            <div class="content-box">
            <p class="ti1"> 一、我们如何收集和使用您的个人信息</p>
            <p class="ti2">1、我们收集哪些您的个人信息</p>
            <p class="ti2">（1）我们提供的业务功能需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：</p>
            <p class="ti2" v-if="productName =='格力服务小程序'">收集你选中的照片或视频信息，用于您的服务信息反馈。为了获取您的服务地址，我们将在获取你的明示同意后，收集你的位置信息。为了识别您的身份和绑定服务工单，我们将在获取你的明示同意后，收集你的手机号</p>
            <p class="ti2" v-else>设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息））；个人位置信息（包括精准定位信息、经纬度等）。</p>
            
            <p class="ti2">2、我们如何使用您的个人信息</p>
            <p class="ti2">为实现向您提供我们的附加功能，您可以选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。</p>
            <p class="ti2">影响的功能包括：</p>
                <template v-if="productName =='格力服务小程序'">
                    <p class="ti2">（1）登录功能：</p>
                    <p class="ti2">我们需要您提供手机号，用于识别您的身份和绑定服务工单，如果您未授权我们获取微信手机号,您可以使用短信验证码的形式补充此信息。</p>
                    <p class="ti2">（2）获取服务地址：</p>
                    <p class="ti2">我们会在您提交工单时要求提供位置信息作为上门服务地址。如果您未授权位置信息，可以通过手动录入的方式告知我们服务地址。我们不会将相关个人位置信息提供给第三方或用于其它与该功能无关的行为。</p>
                    <p class="ti2">（3）服务信息反馈：</p>
                    <p class="ti2">我们会在您提交维修类工单时要求提供故障图片或视频。如果您未授权选中照片或视频，我们将在后续的服务中已电话形式沟通故障信息。</p>
                </template>
                <template v-else>
                    <p class="ti2">（1）派单功能：</p>
                    <p class="ti2">您需要提供必要的个人与设备信息，帮助服务器了解当日活跃情况，用于更加合理调整分派工单的策略。</p>
                    <p class="ti2">（2）采集功能：</p>
                    <p class="ti2">我们会在您采集时要求提供位置信息，目的是对采集结果进行审核，务求给您提供一个更加科学、高效的结算机制。因此在审核时，会利用采集提供的位置信息，帮助校验采集结果，但不会将相关个人位置信息提供给第三方或用于其它与该功能无关的行为。</p>
                    <p class="ti2">（3）撤销已同意授权功能：</p>
                    <p class="ti2">客户端支持您撤销已同意授权的权限，您可在“手机设置️权限”中关闭相关隐私授权。具体为：androis手机：设置️应用️权限，撤回“位置、通讯录、照片、麦克风、相机等已授权系统权限等授权。</p>
                </template>

            <p class="ti2">3、我们如何委托处理、共享、转让、公开披露您的个人信息</p>
                <p class="ti2">（1）委托处理</p>
                    <p class="ti2">本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
                <p class="ti2">（2）共享</p>
                    <p class="ti2">我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。目前，我们会在以下情形中，向您征求您对共享个人信息的明示同意：</p>
                        <p class="ti2 bold-text">a)我们会集成高德地图定位SDK，用于实现定位的功能。该SDK主体为：高德软件有限公司；收集的个人信息包含：位置信息（经纬度、精确位置、粗略位置）【通过IP地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息获取】、设备标识信息（IMEI、IDFA、IDFV、AndroidID、MEID、MAC地址、OAID、IMSI、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统）。了解此情形中目前涉及的公司、组织和个人，请点击此处。
                            【<a class="link" href="https://lbs.amap.com/pages/privacy/">https：//lbs.amap.com/pages/privacy/</a>】
                        </p>
                    <p class="ti2">我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
                <p class="ti2">（3）转让</p>
                    <p class="ti2">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</p>
                        <p class="ti2">	a)在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
                        <p class="ti2">	b)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
                <p class="ti2">（4）公开披露</p>
                    <p class="ti2">我们仅会在以下情形下，公开披露您的个人信息：</p>
                        <p class="ti2">	a)获得您明确同意后；</p>
                        <p class="ti2">	b)基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>

            <br/>

            <p class="ti1">二、我们如何保护您的个人信息</p>
            <p class="ti2">1.数据安全技术措施</p>
                <p class="ti2">我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意代码攻击；例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受 SSL 加密保护；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；</p>
            <p class="ti2">2. 其他安全措施</p>
            <p class="ti2"> 2.1我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
                <p class="ti2">2.2我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
                <p class="ti2">2.3我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
                <p class="ti2">2.4我们建立数据安全委员会并下设信息保护专职部门、数据安全应急响应组织来推进和保障个人信息安全。</p>
                <p class="ti2">2.5加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
                <p class="ti2">2.6我们仅允许有必要知晓这些信息的我们及我们关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与格力的合作关系。</p>
            <p class="ti2">3.互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他我们用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
            <p class="ti2">4.互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</p>
            <p class="ti2">5.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以邮件、信函、电话、推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
            <p class="ti2">6.为应对个人信息泄露、损毁和丢失此类可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</p>
            <p class="ti2">7.如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。</p>
            
            <br/>

            <p class="ti1">三、您的权利</p>
            <p class="ti2">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
            <p class="ti2">在以下情形中，我们将无法响应您的请求：</p>
                <p class="ti2">1、与个人信息控制者履行法律法规规定的义务相关的；</p>
                <p class="ti2">2、与国家安全、国防安全直接相关的；</p>
                <p class="ti2">3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
                <p class="ti2">4、与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
                <p class="ti2">5、个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
                <p class="ti2">6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
                <p class="ti2">7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；涉及商业秘密的。</p>

            <br/>

            <p class="ti1">四、我们如何处理儿童的个人信息</p>
            <p class="ti2">我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。</p>
            <p class="ti2">对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
            <p class="ti2">尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。</p>
            <p class="ti2">如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>

            <br/>

            <p class="ti1">五、您的个人信息如何在全球范围转移</p>
            <p class="ti2">原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
            <p class="ti2">由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。</p>
            <p class="ti2">此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。</p>

            <br/>

            <p class="ti1">六、本政策如何更新</p>
            <p class="ti2">我们的隐私政策可能变更。</p>
            <p class="ti2">未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
            <p class="ti2">对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
            <p class="ti2">本政策所指的重大变更包括但不限于：</p>
            <p class="ti2">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
            <p class="ti2">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
            <p class="ti2">3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
            <p class="ti2">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
            <p class="ti2">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
            <p class="ti2">6、个人信息安全影响评估报告表明存在高风险时。</p>
            <p class="ti2">我们还会将本政策的旧版本存档，供您查阅。</p>

            <br/>

            <p class="ti1">七、如何联系我们</p>
            <p class="ti2">如果您对本隐私政策有任何疑问、意见或建议，通过文章顶部联系方式联系我们。</p>
            <p class="ti2">我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过上述方式与其联系。</p>

            </div>
        </div>
    </section>
  </div>
</template>

<script>

export default {
    name:'privacyPolicy',
    props: {
        productName: {
            type: String,
            default:'格力云售后',
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-content{
    padding: 20px 100px 100px;
    background: white;
    font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif;
}
@media screen and (max-width: 750px){
    .main-content{
        padding: 30px;
        background: white;
        font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif;
    }
    h1{
        font-size: 1.5rem;
    }
}
.header {
    padding-top: 0.5rem;
    text-align: center;
}
.contact{
    padding-bottom: 20px;
}
.summary{
    padding-bottom: 20px;
    li{
        font-size: 13px;
        margin: 10px 0;
    }
}
.ti1 {
    margin: 10px 0;
    font-size: 13px;
    letter-spacing: 0.05rem;
    font-weight: bold;
}
.ti2 {
    margin: 10px 0;
    font-size: 13px;
    line-height: 28px;
    letter-spacing: 0.05rem;
    text-indent: 2em;
}
.bold-text{
    font-weight: bold;
}
.link{
    color: #3385ff;
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/views/privacyPolicy/privacyPolicy.vue